import TypographyPrimary from 'components/Typography/Primary'
import TypographySecondary from 'components/Typography/Secondary'
import CardWrapper from 'components/wrappers/CardWrapper'
import { StyledHorizontalDivider } from 'routes/ChatRouteLayout'
import styled from 'styled-components'

const Examples = ({
    formik,
    chatInputName,
    examples,
    disabled,
    noBorder,
}: {
    formik: any
    chatInputName: string
    examples: string[]
    disabled: boolean
    noBorder?: boolean
}) => {
    const handleClick = (example: string) => {
        formik.setFieldValue(chatInputName, example)

        formik.handleSubmit()
    }

    return (
        <>
            <TypographyPrimary value='Examples' size='medium' semiBold />

            {examples.map(example => {
                return (
                    <StyledCard
                        key={example}
                        onClick={() => handleClick(example)}
                        isDisabled={disabled}
                    >
                        <CardWrapper>
                            <TypographySecondary value={example} size='small' />
                        </CardWrapper>
                    </StyledCard>
                )
            })}
            {!noBorder && <StyledHorizontalDivider />}
        </>
    )
}

export default Examples

const StyledCard = styled.div<{ isDisabled: boolean }>`
    scale: 0.98;
    cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
    pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'auto')};
    opacity: ${({ isDisabled }) => (isDisabled ? 0.8 : 1)};
    &:hover {
        scale: ${({ isDisabled }) => (isDisabled ? '0.98' : '1')};
    }
`
